module.exports = __webpack_public_path__ + "static/img/6.a7ea5de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Accidentes-personales/6.png
// module id = p04Y
// module chunks = 0